import React, { useContext } from 'react'

import useActiveLendersWithRates from 'components/hooks/useActiveLendersWithRates'
import FeaturedLenderBanner from 'components/featured-lender-banner'
import WidgetContext from 'components/widget-context'

import { LENDERS_BY_VERTICAL, STYLES } from './config'

// eslint-disable-next-line react/prop-types
const RichCtaFeaturedLenderBanner = ({ theme }) => {
  const styles = STYLES[theme] || {}
  const { vertical } = useContext(WidgetContext)

  const { lenders, apiVerticalName, lendersNames } = LENDERS_BY_VERTICAL[vertical] || {}

  const [lender1, lender2] = useActiveLendersWithRates({
    vertical: apiVerticalName,
    includeLenders: lenders,
    sortCallback: null,
  })

  return (
    <div className={styles.fontTheme}>
      <FeaturedLenderBanner
        theme={theme}
        vertical={vertical}
        lenders={[
          { slug: lenders[0], name: lendersNames[0], data: lender1 },
          { slug: lenders[1], name: lendersNames[1], data: lender2 },
        ]}
      />
    </div>
  )
}

export default RichCtaFeaturedLenderBanner
